<ng-container *ngIf="_user.userstate | async as statistics">
  <div class="mb-4">
    <app-all-games [user_id]="statistics.id"></app-all-games>
  </div>
  <div class="row">
    <div class="col-md-7">
      <div class="bg-white rounded-10 p-4">
        <div class="statistics-group">
          <h4>Total Stats: {{ (_sport.selectedSport | async) || "All" }}</h4>
          <div class="row statistics-status">
            <div class="col"># of Followers</div>
            <div class="col-auto fw-bold stat-value">
              {{ statistics?.followers | number }}
            </div>
          </div>
          <div class="row statistics-status">
            <div class="col">Days betting</div>
            <div class="col-auto fw-bold stat-value">
              {{ statistics?.days_betting | number }}
            </div>
          </div>
          <div class="row statistics-status">
            <div class="col"># of bets</div>
            <div class="col-auto fw-bold stat-value">
              {{ statistics?.total_bets | number }}
            </div>
          </div>
          <div class="row statistics-status">
            <div class="col">Winnings / (losses)</div>
            <div
              class="col-auto fw-bold stat-value text-green"
              [class.text-danger]="statistics?.total_winnings < 0"
              [class.text-success]="statistics?.total_winnings > 0"
            >
              {{ statistics?.total_winnings || 0 | CustomCurrency }}
            </div>
          </div>
          <div class="row statistics-status">
            <div class="col">W-L-D</div>
            <div class="col-auto fw-bold stat-value">
              {{ statistics?.count_wins | number }}-{{
                statistics?.count_loss | number
              }}-{{ statistics?.count_draw | number }}
            </div>
          </div>
          <div class="row statistics-status">
            <div class="col">Win %</div>
            <div class="col-auto fw-bold stat-value">
              {{ statistics?.win_percent }}%
            </div>
          </div>
          <div class="row statistics-status">
            <div class="col">Avg. bet size</div>
            <div class="col-auto fw-bold stat-value">
              {{ statistics?.average_bet_size | number }}
            </div>
          </div>
          <div class="row statistics-status">
            <div class="col">Avg. odds per bet</div>
            <div class="col-auto fw-bold stat-value">
              {{ statistics?.average_odd }}
            </div>
          </div>
        </div>
        <div class="statistics-group">
          <h4>Yesterday: {{ sport || "All" }}</h4>
          <div class="row statistics-status">
            <div class="col"># of bets</div>
            <div class="col-auto fw-bold stat-value">
              {{ statistics?.last1daysBets | number }}
            </div>
          </div>
          <div class="row statistics-status">
            <div class="col">Winnings / (losses)</div>
            <div
              class="col-auto fw-bold stat-value text-green"
              [class.text-danger]="statistics?.last1daysWinnings < 0"
              [class.text-success]="statistics?.last1daysWinnings > 0"
            >
              {{ statistics?.last1daysWinnings | CustomCurrency }}
            </div>
          </div>
          <div class="row statistics-status">
            <div class="col">W-L-D</div>
            <div class="col-auto fw-bold stat-value">
              {{ statistics?.count_1days_wins | number }}-{{
                statistics?.count_1days_loss | number
              }}-{{ statistics?.count_1days_draw | number }}
            </div>
          </div>
          <div class="row statistics-status">
            <div class="col">Win %</div>
            <div class="col-auto fw-bold stat-value">
              {{ statistics && statistics["1days_win_percent"] }}%
            </div>
          </div>
          <div class="row statistics-status">
            <div class="col">Avg. odds per bet</div>
            <div class="col-auto fw-bold stat-value">
              {{ statistics && statistics["1daysaverage_odd"] }}
            </div>
          </div>
        </div>
        <div class="statistics-group">
          <h4>Last 7 Days: {{ sport || "All" }}</h4>
          <div class="row statistics-status">
            <div class="col"># of bets</div>
            <div class="col-auto fw-bold stat-value">
              {{ statistics?.last7daysBets | number }}
            </div>
          </div>
          <div class="row statistics-status">
            <div class="col">Winnings / (losses)</div>
            <div
              class="col-auto fw-bold stat-value text-green"
              [class.text-danger]="statistics?.last7daysWinnings < 0"
              [class.text-success]="statistics?.last7daysWinnings > 0"
            >
              {{ statistics?.last7daysWinnings | CustomCurrency }}
            </div>
          </div>
          <div class="row statistics-status">
            <div class="col">W-L-D</div>
            <div class="col-auto fw-bold stat-value">
              {{ statistics?.count_7days_wins | number }}-{{
                statistics?.count_7days_loss | number
              }}-{{ statistics?.count_7days_draw | number }}
            </div>
          </div>
          <div class="row statistics-status">
            <div class="col">Win %</div>
            <div class="col-auto fw-bold stat-value">
              {{ statistics && statistics["7days_win_percent"] }}%
            </div>
          </div>
          <div class="row statistics-status">
            <div class="col">Avg. odds per bet</div>
            <div class="col-auto fw-bold stat-value">
              {{ statistics && statistics["7daysaverage_odd"] }}
            </div>
          </div>
        </div>
        <div class="statistics-group">
          <h4>Last 30 Days: {{ sport || "All" }}</h4>
          <div class="row statistics-status">
            <div class="col"># of bets</div>
            <div class="col-auto fw-bold stat-value">
              {{ statistics?.last30daysBets | number }}
            </div>
          </div>
          <div class="row statistics-status">
            <div class="col">Winnings / (losses)</div>
            <div
              class="col-auto fw-bold stat-value text-green"
              [class.text-danger]="statistics?.last30daysWinnings < 0"
              [class.text-success]="statistics?.last30daysWinnings > 0"
            >
              {{ statistics?.last30daysWinnings | CustomCurrency }}
            </div>
          </div>
          <div class="row statistics-status">
            <div class="col">W-L-D</div>
            <div class="col-auto fw-bold stat-value">
              {{ statistics?.count_30days_wins | number }}-{{
                statistics?.count_30days_loss | number
              }}-{{ statistics?.count_30days_draw | number }}
            </div>
          </div>
          <div class="row statistics-status">
            <div class="col">Win %</div>
            <div class="col-auto fw-bold stat-value">
              {{ statistics && statistics["30days_win_percent"] }}%
            </div>
          </div>
          <div class="row statistics-status">
            <div class="col">Avg. odds per bet</div>
            <div class="col-auto fw-bold stat-value">
              {{ statistics && statistics["30daysaverage_odd"] }}
            </div>
          </div>
        </div>
        <div class="statistics-group">
          <h4>Last 90 Days: {{ sport || "All" }}</h4>
          <div class="row statistics-status">
            <div class="col"># of bets</div>
            <div class="col-auto fw-bold stat-value">
              {{ statistics?.last90daysBets | number }}
            </div>
          </div>
          <div class="row statistics-status">
            <div class="col">Winnings / (losses)</div>
            <div
              class="col-auto fw-bold stat-value"
              [class.text-danger]="statistics?.last90daysWinnings < 0"
              [class.text-success]="statistics?.last90daysWinnings > 0"
            >
              {{ statistics?.last90daysWinnings | CustomCurrency }}
            </div>
          </div>
          <div class="row statistics-status">
            <div class="col">W-L-D</div>
            <div class="col-auto fw-bold stat-value">
              {{ statistics?.count_90days_wins | number }}-{{
                statistics?.count_90days_loss | number
              }}-{{ statistics?.count_90days_draw | number }}
            </div>
          </div>
          <div class="row statistics-status">
            <div class="col">Win %</div>
            <div class="col-auto fw-bold stat-value">
              {{ statistics && statistics["90days_win_percent"] }}%
            </div>
          </div>
          <div class="row statistics-status">
            <div class="col">Avg. odds per bet</div>
            <div class="col-auto fw-bold stat-value">
              {{ statistics && statistics["90daysaverage_odd"] }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="col-md-5">
    <div class="bg-white rounded-10 p-3">
      <h5 class="mb-4 fw-bold">Winnings / (losses) over time</h5>
      <img
        src="../../../../assets/img/mystatisitcs.svg"
        alt="mystatistics"
        class="img-fliud w-100"
      />
    </div>
  </div> -->
  </div>
</ng-container>
